function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_434",
  "data-name": "Group 434",
  transform: "translate(-0.254)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_12",
  "data-name": "Ellipse 12",
  cx: 21,
  cy: 21,
  r: 21,
  transform: "translate(0.254)",
  fill: "#eeeff3"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_246",
  "data-name": "Group 246",
  transform: "translate(11 11)"
}, /*#__PURE__*/React.createElement("path", {
  id: "other_fee",
  "data-name": "other fee",
  d: "M23.106,14a9.106,9.106,0,1,0,9.106,9.106A9.106,9.106,0,0,0,23.106,14Zm.689,13.217V28.8h-1.5V27.324a6.165,6.165,0,0,1-2.6-.644l.459-1.8a5.4,5.4,0,0,0,2.542.675c.873,0,1.485-.353,1.485-.951,0-.583-.506-.951-1.639-1.335-1.638-.552-2.756-1.32-2.756-2.808a2.811,2.811,0,0,1,2.588-2.731V16.276h1.5v1.35a5.4,5.4,0,0,1,2.236.507l-.459,1.734a4.76,4.76,0,0,0-2.2-.537c-1,0-1.317.445-1.317.875,0,.491.536.829,1.838,1.3,1.837.644,2.557,1.488,2.557,2.885A2.913,2.913,0,0,1,23.795,27.217Z",
  transform: "translate(-13 -13)",
  fill: "#cc96f1"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_117",
  "data-name": "Rectangle 117",
  width: 20,
  height: 20,
  transform: "translate(0.254)",
  fill: "none"
})));

var SvgOtherFees = function SvgOtherFees(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOtherFees, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/other-fees.71fa1fc4.svg";
export { ForwardRef as ReactComponent };